self["MonacoEnvironment"] = (function (paths) {
      function stripTrailingSlash(str) {
        return str.replace(/\/$/, '');
      }
      return {
        getWorkerUrl: function (moduleId, label) {
          var pathPrefix = typeof __webpack_public_path__ === 'string' ? __webpack_public_path__ : "/static/";
          var result = (pathPrefix ? stripTrailingSlash(pathPrefix) + '/' : '') + paths[label];
          if (/^((http:)|(https:)|(file:)|(\/\/))/.test(result)) {
            var currentUrl = String(window.location);
            var currentOrigin = currentUrl.substr(0, currentUrl.length - window.location.hash.length - window.location.search.length - window.location.pathname.length);
            if (result.substring(0, currentOrigin.length) !== currentOrigin) {
              var js = '/*' + label + '*/importScripts("' + result + '");';
              var blob = new Blob([js], { type: 'application/javascript' });
              return URL.createObjectURL(blob);
            }
          }
          return result;
        }
      };
    })({
  "editorWorkerService": "editor.worker.js"
});
require("./standalone/browser/accessibilityHelp/accessibilityHelp.js");
require("./contrib/bracketMatching/bracketMatching.js");
require("./contrib/caretOperations/caretOperations.js");
require("./contrib/clipboard/clipboard.js");
require("./contrib/codeAction/codeActionContributions.js");
require("./contrib/codelens/codelensController.js");
require("./contrib/colorPicker/colorDetector.js");
require("./contrib/comment/comment.js");
require("./contrib/contextmenu/contextmenu.js");
require("./browser/controller/coreCommands.js");
require("./contrib/cursorUndo/cursorUndo.js");
require("./contrib/dnd/dnd.js");
require("./contrib/find/findController.js");
require("./contrib/folding/folding.js");
require("./contrib/fontZoom/fontZoom.js");
require("./contrib/format/formatActions.js");
require("./contrib/gotoError/gotoError.js");
require("./standalone/browser/quickOpen/gotoLine.js");
require("./contrib/hover/hover.js");
require("./standalone/browser/iPadShowKeyboard/iPadShowKeyboard.js");
require("./contrib/inPlaceReplace/inPlaceReplace.js");
require("./standalone/browser/inspectTokens/inspectTokens.js");
require("./contrib/linesOperations/linesOperations.js");
require("./contrib/links/links.js");
require("./contrib/multicursor/multicursor.js");
require("./contrib/parameterHints/parameterHints.js");
require("./standalone/browser/quickOpen/quickCommand.js");
require("./standalone/browser/quickOpen/quickOutline.js");
require("./standalone/browser/referenceSearch/standaloneReferenceSearch.js");
require("./contrib/rename/rename.js");
require("./contrib/smartSelect/smartSelect.js");
require("./contrib/snippet/snippetController2.js");
require("./contrib/suggest/suggestController.js");
require("./standalone/browser/toggleHighContrast/toggleHighContrast.js");
require("./contrib/toggleTabFocusMode/toggleTabFocusMode.js");
require("./contrib/caretOperations/transpose.js");
require("./contrib/wordHighlighter/wordHighlighter.js");
require("./contrib/wordOperations/wordOperations.js");
require("./contrib/wordPartOperations/wordPartOperations.js");
module.exports = require("!!./editor.api.js");
require("../basic-languages/cpp/cpp.contribution.js");
require("../basic-languages/python/python.contribution.js");
require("../basic-languages/lua/lua.contribution.js");
require("../basic-languages/javascript/javascript.contribution.js");